"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionAnimInit = void 0;
const gsap_1 = __importDefault(require("gsap"));
const all_1 = require("gsap/all");
const anims_1 = require("../ts/utils/anims");
const { DURATION } = anims_1.animationConfig;
// Fix flicker in screen with refresh rate higher than 60hz
gsap_1.default.ticker.fps(240);
gsap_1.default.registerPlugin(all_1.ScrollTrigger);
const scrollTriggerConfig = {
    start: "top+=50 center-=100",
    end: "bottom+=100 center+=100",
    toggleActions: "play reverse play reverse",
};
const scrollTriggerConfigScale = {
    start: "top-=50 80%",
    end: "bottom 10%",
    toggleActions: "play reverse play reverse",
};
function sectionAnimInit({ emisionesElId }) {
    let mm = gsap_1.default.matchMedia();
    document.addEventListener("reactTabClicked", (e) => {
        const emisionesEl = document.getElementById(emisionesElId);
        if (!emisionesEl) {
            console.log("No emisiones root element found");
            return;
        }
        const customEvent = e;
        emisionesEl.style.height = `${customEvent.detail}px`;
        all_1.ScrollTrigger.refresh();
    });
    let containers = gsap_1.default.utils.toArray(".component-container[data-animated='true']:not(.--react):not(:has(#emisiones_root))");
    if (!containers.length) {
        console.log("No containers found");
        return;
    }
    mm.add("(max-width: 767px)", () => {
        let bgEls = gsap_1.default.utils.toArray(".component-container-bg-el");
        let componentWrapperEls = gsap_1.default.utils.toArray(".component-container-content");
        gsap_1.default.set(containers, {
            padding: 0,
            // scale: 1,
        });
        gsap_1.default.set(bgEls, {
            borderRadius: "0",
        });
        gsap_1.default.set(componentWrapperEls, {
            borderRadius: "0",
        });
    });
    mm.add("(min-width: 768px)", () => {
        containers.forEach((container) => {
            // Padding animation
            gsap_1.default.to(container, {
                padding: 0,
                duration: DURATION,
                scrollTrigger: Object.assign({ trigger: container }, scrollTriggerConfig),
            });
            // Scale animation
            // Set in a different scroll trigger becuase I need different start points
            gsap_1.default.to(container, {
                // scale: 1,
                duration: DURATION,
                scrollTrigger: Object.assign({ trigger: container }, scrollTriggerConfigScale),
            });
            let bgEl = container.querySelector(".component-container-bg-el");
            let componentWrapperEl = container.querySelector(".component-container-content");
            if (bgEl) {
                gsap_1.default.to(bgEl, {
                    duration: DURATION,
                    borderRadius: 0,
                    scrollTrigger: Object.assign({ trigger: container }, scrollTriggerConfig),
                });
            }
            if (componentWrapperEl) {
                gsap_1.default.to(componentWrapperEl, {
                    duration: DURATION,
                    borderRadius: 0,
                    scrollTrigger: Object.assign({ trigger: container }, scrollTriggerConfig),
                });
            }
        });
    });
}
exports.sectionAnimInit = sectionAnimInit;
